import Collection from '../../collection';
import Filters from '../../view/module/schedule/launch.filters';
import Model from '../../model/model';
import Module from '../../core/module';
import Schedule from '../../model/schedule';
import ScheduleFormModule from './form';
import ScheduleTemplateModule from './templates.form';

import { ask, } from '../../utils/popups';
import { del } from '../../http/api';
import { beginLock, endLock } from '../../loader';






const 
    POPUP = 'schedule-card-templates--popup',
    REPLACE = 'schedule-card-templates--open-replace';





export default Module.extend( {

    template: 'jst/module.schedule.templates.list',

    url() {
        return `schedule/${this.options.schedule.id}/templates`;
    },

    open({ id, schedule }) {
        const fetchingSchedule = schedule
            ? Promise.resolve( schedule ) : Schedule.byId( id );

        this.lastFiltering_ = Promise.resolve();
        this.filtersModel = new Filters.Model( this.state().filters );
        this.options.templates = new Collection( {
            endpoint: `timetables/${schedule ? schedule.id : id}/templates?apiVersion=2.0`,
            responseAt: 'items',
            countAt: 'total',
        } );
        
        const fetchingTemplates = fetch.call( this );

        return Promise.all( [fetchingSchedule, fetchingTemplates] )
            .then( ([schedule]) => this.options.schedule = schedule )
            .then( () => this.bind( this.filtersModel ) );
    },

    start() {
        return this;
    },

    stop() {
        return this;
    },

    serialize() {
        const { schedule } = this.options;
        return { 
            schedule: schedule instanceof Model
                ? schedule.toJSON()
                : schedule
        };
    },

    events: {

        'click .-back'() {
            this.trigger( Module.BACK );
        },

        'click .-popup-schedule-template'({currentTarget}) {
            const { templateId } = currentTarget.dataset;
            this.trigger( ScheduleTemplateModule.POPUP_EDIT, 
                this.options.schedule,
                templateId );
        },

        'click .-remove-schedule-template'({currentTarget}) {
            const 
                { templateId } = currentTarget.dataset,
                { schedule } = this.options;

            return ask( 'schedule::modal delete template - confirmation text', 
                'schedule::modal delete template - title', 
                'actions::yes', 
                'actions::no',
                () => {
                    beginLock( this );
                    return new Schedule( { id: schedule.id, } )
                        .patch( { templates: {
                            remove: [{ id: +templateId }]
                        }, } );
                } )
                .then( () => {
                    if (this.options.templates.length == 1 && this.options.templates.total > 1)
                        if (this.state().page > 1)
                            this.setState( { page: this.state().page - 1, } );
                } )
                .then( () => fetch.call( this ) )
                .then( () => Promise
                    .all( [this.Templates.render(), this.Paging.render()] ) )
                .then( () => endLock( this ), () => endLock( this ) )
                .then( () => this.navigated() );
        },

        'click .-new-template'() {
            this.trigger( ScheduleTemplateModule.POPUP_NEW, 
                this.options.schedule );
        },

    },

    [Module.event( 'Filters:change' )](filters) {
        return this.setState( { filters, page: 1, } ),
            fetch.call( this )
                .then( () => Promise.all( [this.Templates.render(), this.Paging.render()] ) )
                .then( () => this.navigated() );
    },

    [Module.event( 'Paging:page')](page) {
        return this.setState( { page: +page, } ),
            fetch.call( this )
                .then( () => Promise.all( [this.Templates.render(), this.Paging.render()] ) )
                .then( () => this.navigated() );
    },

    [Module.event( ':schedule:edit' )]() {
        return this.trigger( ScheduleFormModule.POPUP_EDIT,
            this.options.schedule );
    },

    [Module.event( ':schedule:delete' )]({ id }) {
        return ask( 'schedule::modal delete schedule - confirmation text', 
            'schedule::modal delete schedule - title', 
            'actions::yes', 
            'actions::no',
            () => del( `/timetables/${id}` )
                .blocking( this ).cerebellum()
                .execute() )
            .then( () => this.trigger( Module.BACK ) );
    },

}, {

    POPUP,

    REPLACE,

} );





function fetch() {
    const
        { templates, } = this.options,
        { filters, page, } = this.state();

    return this.lastFiltering_ = this.lastFiltering_
        .then( () => templates.filter( {
            ...filters,
            page,
            limit: 12,
        } ) );
}


// WEBPACK FOOTER //
// ./src/js/module/schedule/templates.list.js